export const getQuizList = (payload?: any) => ({
    type: "@saga/GET_QUIZ_LIST",
    payload
});

